module.exports = __webpack_public_path__ + "img/banner-4.8ec94c02.webp";